import { render, staticRenderFns } from "./Geral.vue?vue&type=template&id=c243dd5c"
import script from "./Geral.vue?vue&type=script&lang=js"
export * from "./Geral.vue?vue&type=script&lang=js"
import style0 from "./Geral.vue?vue&type=style&index=0&id=c243dd5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports